import { CalculationState, initialCalculationState, initialConfiguration, Configuration } from "./sections";

type AppState = {
  configuration: Configuration;
  calculation: CalculationState;
};

const initialAppState: AppState = {
  configuration: initialConfiguration,
  calculation: initialCalculationState,
};

export { type AppState, initialAppState };
